/**
 * Created by mateimisarca on 01/12/2019
 */

import ToastNotification from './toast-notifications';

export default ToastNotification;
